"use client";
import Image from "next/image";
import { useState } from "react";
import { Box } from "lucide-react";
import { shouldSkipProductImageOptimization } from "@/lib/product-image-url";

const localImageDimensions: Record<string, readonly [number, number]> = {
  "/images/products/1.avif": [640, 640],
  "/images/products/2.avif": [640, 479],
  "/images/products/3.avif": [640, 480],
  "/images/products/4.avif": [640, 479],
  "/images/products/5.avif": [640, 480],
  "/images/products/6.avif": [640, 480],
  "/images/products/dragon-keychain.webp": [1024, 768],
};

export function ProductImage({
  src,
  alt,
  priority = false,
  hoverSrc,
  sizes = "(max-width: 640px) 50vw, (max-width: 1000px) 33vw, 25vw",
}: {
  src?: string;
  alt: string;
  priority?: boolean;
  hoverSrc?: string;
  sizes?: string;
}) {
  const [failed, setFailed] = useState(false);
  const [hoverRequested, setHoverRequested] = useState(false);
  const [hoverReady, setHoverReady] = useState(false);
  const [width, height] = localImageDimensions[src ?? ""] ?? [800, 800];
  return src && !failed ? (
    <>
    <Image
      src={src}
      alt={alt}
      width={width}
      height={height}
      sizes={sizes}
      unoptimized={shouldSkipProductImageOptimization(src)}
      priority={priority}
      className="product-photo-content"
      onPointerEnter={(event) => { if (hoverSrc && event.pointerType === "mouse") setHoverRequested(true); }}
      onFocus={() => { if (hoverSrc) setHoverRequested(true); }}
      onError={() => setFailed(true)}
    />
    {hoverRequested && hoverSrc && hoverSrc !== src && <Image
      src={hoverSrc}
      alt=""
      width={localImageDimensions[hoverSrc]?.[0] ?? 800}
      height={localImageDimensions[hoverSrc]?.[1] ?? 800}
      sizes={sizes}
      unoptimized={shouldSkipProductImageOptimization(hoverSrc)}
      className={`product-photo-content product-photo-hover${hoverReady ? " is-ready" : ""}`}
      onLoad={() => setHoverReady(true)}
      onError={() => setHoverRequested(false)}
    />}
    </>
  ) : (
    <div className="image-placeholder">
      <Box size={40} />
      <span>تصویری برای این محصول ثبت نشده است</span>
    </div>
  );
}
